(() => {
  if (
    window.__nimstrataBloomreachTracking ||
    typeof window.fetch !== "function"
  )
    return;
  window.__nimstrataBloomreachTracking = true;

  const { pageType, domainKey } = document.currentScript.dataset;
  const originalFetch = window.fetch;
  let latestRequest = 0;
  let lastEvent = "";

  const shopifyId = (value, type) => {
    const id = String(Array.isArray(value) ? (value[0] ?? "") : (value ?? ""));
    if (/^\d+$/.test(id)) return `gid://shopify/${type}/${id}`;
    return new RegExp(`^gid://shopify/${type}/\\d+$`).test(id) ? id : null;
  };

  const track = async (response, params, href, request) => {
    if (!response.ok) return;
    const body = await response.clone().json();
    const docs = body?.response?.docs;
    if (!Array.isArray(docs) || body.keywordRedirect?.["redirected url"])
      return;

    const resultsPerPage = Number(params.get("rows"));
    const start = Number(params.get("start") || 0);
    if (
      !Number.isSafeInteger(resultsPerPage) ||
      resultsPerPage <= 0 ||
      !Number.isSafeInteger(start) ||
      start < 0 ||
      start % resultsPerPage !== 0
    )
      return;

    const productVariants = [];
    const seen = new Set();
    for (const doc of docs) {
      if (!doc || String(doc.docType).toLowerCase() === "content") continue;
      const id = shopifyId(doc.pid, "Product");
      if (!id || seen.has(id)) continue;
      seen.add(id);
      productVariants.push({ product: { id } });
    }

    const result = {
      productVariants,
      pageNumber: start / resultsPerPage + 1,
      resultsPerPage,
    };
    const isCollection = params.get("search_type") === "category";
    if (isCollection) {
      result.id = shopifyId(
        params.get("cat_id") || params.get("q"),
        "Collection",
      );
      if (!result.id) return;
    } else {
      result.query = params.get("q");
      if (!result.query?.trim()) return;
    }

    const name = isCollection ? "rcc:collection" : "rcc:search";
    const payload = {
      data: { [isCollection ? "collection" : "searchResult"]: result },
    };
    const key = JSON.stringify([
      name,
      payload,
      params.getAll("fq"),
      params.get("sort"),
    ]);

    // Shopify's pixel runtime owns consent and delivery. Never send directly to /v1/event.
    const publish = (attempt = 0) => {
      if (
        request !== latestRequest ||
        window.location.href !== href ||
        key === lastEvent
      )
        return;
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish !== "function") {
        // Wait up to 10 seconds for Shopify analytics to load.
        if (attempt < 100) window.setTimeout(() => publish(attempt + 1), 100);
        return;
      }
      try {
        const published = analytics.publish(name, payload);
        if (published === false) return;
        lastEvent = key;
        Promise.resolve(published).catch(() => {
          if (lastEvent === key) lastEvent = "";
        });
      } catch {
        // Analytics must never break storefront search.
      }
    };
    publish();
  };

  // The installed Bloomreach Discovery SDK uses fetch for both keyword and category results.
  window.fetch = function (...args) {
    const pending = originalFetch.apply(this, args);
    try {
      const input = args[0];
      const url = new URL(
        typeof input === "string" ? input : input.url || input.href,
        window.location.href,
      );
      const params = url.searchParams;
      const type = params.get("search_type");
      const method = args[1]?.method || input.method || "GET";
      if (
        method.toUpperCase() === "GET" &&
        ["https://core.dxpapi.com", "https://staging-core.dxpapi.com"].includes(
          url.origin,
        ) &&
        /^\/api\/v1\/core\/?$/.test(url.pathname) &&
        params.get("request_type") === "search" &&
        params.get("domain_key") === domainKey &&
        ((pageType === "collection" && type === "category") ||
          (pageType === "search" && type === "keyword"))
      ) {
        const href = window.location.href;
        const request = ++latestRequest;
        pending
          .then((response) => track(response, params, href, request))
          .catch(() => {});
      }
    } catch {
      // Unrelated requests and malformed responses pass through unchanged.
    }
    return pending;
  };
})();
